import { render, staticRenderFns } from "./dictModal.vue?vue&type=template&id=c2e64afa&scoped=true"
import script from "./dictModal.vue?vue&type=script&lang=js"
export * from "./dictModal.vue?vue&type=script&lang=js"
import style0 from "./dictModal.vue?vue&type=style&index=0&id=c2e64afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e64afa",
  null
  
)

export default component.exports